const it = {
  avisoLegal: "Bozza orientativa generata dai dati registrati in NuvliPro. Non sostituisce la consulenza professionale. Verificala con il tuo commercialista prima di presentarla.",
  lockPago: "Le esportazioni per il commercialista sono una funzione a pagamento.",
  imp: { IVA: "IVA", IGIC: "IGIC", IPSI: "IPSI" },
  ter: { comun: "Territorio comune", canarias: "Canarie", ceuta_melilla: "Ceuta e Melilla", foral_pv: "Paesi Baschi", foral_navarra: "Navarra" },
  tipo: { autonomo: "Lavoratore autonomo (persona fisica)", sociedad: "Società" },
  q: { 1: "T1 · Gen–Mar", 2: "T2 · Apr–Giu", 3: "T3 · Lug–Set", 4: "T4 · Ott–Dic" },
  periodoT: "T{{n}} {{year}}",
  periodoP: "Acconto {{n}} {{year}}",
  sub: "{{imp}} e IRPF per trimestre e riepilogo annuale",
  pie: "Gli importi sono calcolati automaticamente dalle fatture emesse e dalle spese registrate in ogni trimestre.",
  regimen: {
    proTitulo: "Piano Pro:",
    proTexto: "regime fiscale automatico per territorio (IVA, IGIC e Haciendas Forales), Modello 420 alle Canarie, Modello 202 per le società, Modello 111, avvisi di scadenza e controllo della qualità dei dati.",
    pasarPro: "Passa a Pro",
    modelo: " (modello {{m}})",
    pagos: "acconti: modello {{m}}",
    corregido: "Corretto manualmente · cambia",
    detectado: "Rilevato automaticamente · correggi",
    faltan: "Manca il tuo dato fiscale ({{que}}): abbiamo ipotizzato territorio comune e lavoratore autonomo finché non lo completi.",
    cp: "codice postale", nif: "NIF/CIF", y: " e ",
    foral: "Il tuo domicilio fiscale è in {{nombre}}: l'IVA e gli acconti si presentano alla {{hacienda}}, con modelli e scadenze forali propri. Questa bozza è una guida; la dichiarazione la prepara il tuo commercialista.",
    ipsi: "A Ceuta e Melilla si applica l'IPSI al posto dell'IVA. NuvliPro non la calcola ancora: chiedi al tuo commercialista di preparare la dichiarazione.",
  },
  card: {
    baseVentas: "Imponibile vendite", baseGastos: "Imponibile spese", rep: "{{imp}} a debito", sop: "{{imp}} a credito",
    irpf: "Ritenuta IRPF", horas: "Ore lavorate", bases: "Imponibili per aliquota {{imp}}", base: "{{imp}} {{pct}}% · imponibile",
    resultado: "Risultato {{imp}} ({{estado}})", aIngresar: "da versare", aCompensar: "da compensare",
    igicCanarias: "IGIC · cantieri alle Canarie", ivaFuera: "IVA · cantieri fuori dalle Canarie",
    ipsiRep: "IPSI a debito", ipsiAviso: "IPSI non calcolata: la prepara il tuo commercialista.",
    isp: "Inversione contabile (reverse charge) · a parte", ispEmitidas: "Emesse (imponibile, senza imposta)", ispRecibidas: "Ricevute (imponibile)",
    ispCuota: "Imposta autoliquidata (si dichiara e si detrae)",
  },
  btn: {
    docGestoria: "Doc. commercialista", docAnual: "Doc. commercialista (annuale)", enviar: "Invia", m: "M.{{m}}", modelo: "Modello {{m}}",
    m420Pro: "Modello 420: Piano Pro", excel: "Excel", ver130: "Vedi 130",
  },
  anual: { titulo: "Riepilogo annuale {{year}}", ipsi: "IPSI a debito (non calcolata)", resultado: "Risultato {{imp}} annuale" },
  doc: { gestoria: "Documento per il commercialista", modelo: "Modello {{m}}" },
  toast: {
    generado: "{{doc}} generato", trimestre: " (T{{n}})", anual: " (annuale {{year}})", error: "Impossibile generare: {{doc}}",
    excelOk: "Report {{year}} esportato per il commercialista (XLSX)", excelError: "Impossibile esportare il report",
    m130Error: "Impossibile calcolare il Modello 130", reduccionError: "Impossibile salvare la riduzione",
  },
  m130: {
    titulo: "Modello 130 — IRPF", acum: "(cumul. T{{n}})", anual: "(annuale {{year}})",
    desc: "Acconto cumulato dell'anno, meno le ritenute e quanto versato nei trimestri precedenti.",
    ingresos: "Ricavi computabili (cumulati)", gastos: "Spese deducibili (cumulate)", rendimiento: "Reddito netto",
    reduccion: "Riduzione {{pct}} % spese di difficile giustificazione", pago: "Acconto ({{pct}} %)",
    retenciones: "Ritenute subite", anteriores: "Versamenti dei trimestri precedenti",
    aIngresar: "Risultato da versare", negativo: "Risultato negativo (da versare: 0 €)",
    marcar: "Applica la riduzione del {{pct}} % per spese di difficile giustificazione (max. {{max}}/anno). Verificalo con il tuo commercialista.",
    cerrar: "Chiudi", pdf: "Scarica PDF",
  },
  m202: {
    titulo: "Modello 202 — acconti {{year}} (stima)",
    desc: "Imposta sulle società: {{pct}} % dell'utile cumulato dell'anno. Il tuo commercialista può usare un altro metodo.",
    plazo: "Acconto {{p}} · si presenta dal 1 al 20 {{mes}}", mes: { 1: "aprile", 2: "ottobre", 3: "dicembre" },
    tramo: { 3: "gen–mar", 9: "gen–set", 11: "gen–nov" }, beneficio: "Utile cumulato ({{tramo}})",
    cuota: "{{pct}} % dell'utile", menos: "Ritenute e acconti precedenti", estimacion: "Stima da versare",
  },
  m111: {
    titulo: "Modello 111 — ritenute {{year}}",
    desc: "Ritenute sulle buste paga (le inserisci tu) e sui professionisti che paghi con ritenuta (prese dalle tue spese).",
    nominas: "Ritenute sulle buste paga (manuale)", profesionales: "Professionisti: {{n}} percettore/i, imponibile {{base}}",
    total: "Totale da versare", guardado: "Ritenute buste paga del T{{n}} salvate",
    errorGuardar: "Impossibile salvare l'importo", invalido: "Inserisci un importo valido, ad esempio 1.234,56",
  },
  enviar: {
    titulo: "Invia il T{{n}} {{year}} al tuo commercialista",
    desc: "Riceverà un'email con questi PDF allegati. Se risponde, l'email arriverà a te.",
    email: "Email del commercialista", placeholder: "commercialista@esempio.it", boton: "Invia", ok: "T{{n}} {{year}} inviato a {{email}} ({{docs}} PDF)",
    error: "Controlla l'email del commercialista",
  },
  avisos: {
    plazos: "Prossime scadenze", sinPlazos: "Nessuna scadenza imminente.",
    forales: "Scadenze forali: i modelli si presentano alla tua Hacienda Foral e li prepara il tuo commercialista.",
    modelos: "Modelli {{m}}", rango: "{{periodo}}: dal {{desde}} al {{hasta}}",
    hoy: "Scade oggi", unDia: "Manca 1 giorno", dias: "Mancano {{n}} giorni",
    recordatorio: "Ti avvisiamo con una notifica e un'email 10 giorni prima della fine di ogni scadenza.",
    calidad: "Qualità dei dati {{year}}", ok: "Tutto in ordine: non mancano dati nelle tue fatture di quest'anno.",
    revisar: "Controlla", exenta: "Segna come esente", exentaOk: "Spesa segnata come esente", exentaError: "Impossibile segnare la spesa",
  },
  calidad: {
    facturas_nif: "Fatture emesse senza NIF del cliente o con NIF errato",
    facturas_cp_obra: "Fatture di cantiere senza codice postale del cantiere (aggiungilo nella scheda del cantiere)",
    gastos_sin_impuesto: "Fatture ricevute senza imposta indicata (IVA o IGIC a 0)",
    gastos_nif: "Fatture ricevute senza NIF del fornitore o con NIF errato",
  },
  ajustes: {
    titulo: "Regime fiscale (Controllo trimestrale)", det1: "Rilevato automaticamente:", det2: "dal tuo codice postale e",
    det3: "dal tuo NIF/CIF. Cambialo solo se non è corretto.",
    nota: "Questa modifica riguarda solo il Controllo trimestrale. Le nuove fatture continuano a proporre l'imposta in base al tuo codice postale e a quello del cliente.",
    territorio: "Territorio fiscale", tipo: "Tipo di contribuente", automatico: "Automatico ({{x}})",
    autonomo130: "Autonomo (modello 130)", sociedad202: "Società (modello 202)",
    bloqueado: "Il regime automatico fa parte del Piano Pro.", guardado: "Regime fiscale salvato", error: "Impossibile salvare",
  },
};

export default it;
